export default "__VITE_ASSET__BAbt47mZ__"